import Reviews from './Reviews.jsx';

function Home() {
  return (
    <div data-testid="home">
      <Reviews />
    </div>
  )
}

export default Home;
